export enum CompanyStatus {
  Created = 'created',
  Pending = 'pending',
  InReview = 'in-review',
  Approved = 'approved',
  Rejected = 'rejected',
}
